import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, Typography } from '@mui/material';

import { date } from '@/utilities/dateUtils';
import { ctxRefuel } from '@/contexts/RefuelsCtx';

import './RefuelStyle.css';

export function RefuelsSummary() {
  const ctx = useContext(ctxRefuel);
  const { t } = useTranslation();
  const [summRefuel, setSummRefuel] = useState<number | undefined>(undefined);

  const [summarySelectedDates, setSummarySelectedDates] = useState(ctx?.selectedDates);
  const [prevSelectedTarget, setPrevSelectedTarget] = useState(ctx?.selectedTarget);

  useEffect(() => {
    if (!ctx) return;
    if (ctx.refuels) {
      setSummRefuel(ctx.refuels.reduce((acc, refuel) => acc + refuel.fillAmount, 0));

      if (ctx.selectedDates) {
        setSummarySelectedDates(ctx.selectedDates);
      }
    }
  }, [ctx]);

  useEffect(() => {
    if (!ctx) return;
    if (ctx.selectedTarget !== prevSelectedTarget) {
      setSummarySelectedDates(undefined);
      setPrevSelectedTarget(ctx.selectedTarget);
    }
  }, [ctx, prevSelectedTarget]);

  if (!ctx) return null;

  return (
    <div>
      <Card className="refuels-summary-card">
        <CardContent className="refuels-summary-card-content" data-qa-element-id="refuel_summary_panel">
          <Typography variant="h5" component="div">
            <span className="refuels-summary-title" data-qa-element-id="refuel_summary_panel_title">
              {t('refuels.aggregatedDataSort') + ' ('}
              {ctx.refuels?.length ? ctx.refuels.length : 0} {`${t('refuels.summary.refueling').toLowerCase()})`}
            </span>
          </Typography>
          <Typography variant="body2" component="div">
            <div className="refuels-summary-card-body">
              <div className="refuels-summary-card-body-titles">
                {summarySelectedDates && (
                  <>
                    <span data-qa-element-id="date_intarval_label">{t('refuels.summary.dateRange')}:</span> <br />
                  </>
                )}
                {ctx.refuels && <span data-qa-element-id="fuel_fillings_label">{t('refuels.title')}:</span>}
              </div>
              <div>
                {summarySelectedDates && (
                  <>
                    <b data-qa-element-id="refuel_summary_date_interval">
                      {date(summarySelectedDates.from, t)} - {date(summarySelectedDates.to, t)}
                    </b>
                    <br />
                  </>
                )}
                {ctx.refuels && (
                  <>
                    <b className="refuels-summary-fillAmount" data-qa-element-id="refuel_summary_fill_amount">
                      {summRefuel?.toFixed(1)} L
                    </b>
                  </>
                )}
              </div>
            </div>
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
}
